import React, { useState } from "react";
import PropTypes from "prop-types";
import { basicUTCFormat } from "../../extends/NumberFormat";
import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { CheckCircle, RadioButtonUnchecked, Reply } from "@mui/icons-material";
import CommentReply from "../../components/CommentReply/CommentReply";
import ReplyComments from "./ReplyComments";

const styles = {
  flex: {
    display: "flex",
    cursor: "pointer",
  },
  fontSize: {
    fontSize: "0.8rem",
  },
  blue: {
    color: "#0091FF",
  },
  date: {
    color: "gray",
    fontSize: 12,
    lineHeight: "1",
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
    marginBottom: 20,
  },
  padding: {
    padding: 13,
  },
  line: {
    lineHeight: "1.5",
    fontSize: "0.9rem",
  },
  lineDone: {
    lineHeight: "1.5",
    fontSize: "0.9rem",
    textDecoration: "line-through",
  },
};

const DisplayComments = (props) => {
  const { classes, comments, onDone, onReply, replyDisabled = true } = props;
  const [selectedComment, setSelectedComment] = useState(null);
  const handleDone = (comment) => {
    if (onDone) onDone(comment);
  };

  if (!comments?.length) {
    return <Typography>No Comments</Typography>;
  }
  return (
    <>
      <List dense>
        {comments
          .filter((c) => !c.parentThreadId)
          .sort((a, b) => -b?.recAddedDate?.localeCompare(a?.recAddedDate))
          .map((element, index) => {
            const replies = comments
              .filter((c) => c.parentThreadId === element.threadId)
              .sort((a, b) => -b?.recAddedDate?.localeCompare(a?.recAddedDate));
            return (
              <ListItem
                key={index}
                disablePadding
                sx={{
                  border: "1px solid #F6F6F9",
                  borderRadius: 3,
                  background: "#F6F6F9",
                  padding: 2,
                  marginBottom: 1,
                  alignItems: "flex-start",
                }}
              >
                <Stack flex={1}>
                  <Stack direction="row" justifyContent="space-between">
                    <ListItemText
                      primary={element?.content}
                      secondary={
                        <Typography variant="caption">
                          {basicUTCFormat(element.recAddedDate)}
                        </Typography>
                      }
                    ></ListItemText>
                    {!replyDisabled &&
                      !element?.isArchived &&
                      replies?.length === 0 && (
                        <IconButton
                          color="primary"
                          onClick={() => setSelectedComment(element)}
                        >
                          <Reply></Reply>
                          <Typography variant="caption">Reply</Typography>
                        </IconButton>
                      )}
                    <IconButton
                      sx={{ gap: 0.5 }}
                      onClick={() => {
                        handleDone(element);
                      }}
                    >
                      {element.isArchived ? (
                        <CheckCircle sx={{ color: "green" }} />
                      ) : (
                        <RadioButtonUnchecked className={classes.blue} />
                      )}
                      <Typography
                        className={classes.fontSize}
                        variant="subtitle1"
                      >
                        Done
                      </Typography>
                    </IconButton>
                  </Stack>
                  {!replyDisabled && replies?.length > 0 && (
                    <ReplyComments
                      replies={replies}
                      onReply={(c) => {
                        if (!c) {
                          c = element;
                        }
                        setSelectedComment(c);
                      }}
                    ></ReplyComments>
                  )}
                </Stack>
              </ListItem>
            );
          })}
      </List>
      {Boolean(selectedComment?.id) && (
        <CommentReply
          comment={selectedComment}
          onClose={() => setSelectedComment(null)}
          onReply={async (id, to, subject, content) => {
            if (!onReply) {
              setSelectedComment(null);
            }
            await onReply(id, to, subject, content);
            setSelectedComment(null);
          }}
        ></CommentReply>
      )}
    </>
  );
};

DisplayComments.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DisplayComments);
